import styled from 'styled-components';

export const Grid = styled.div`
  height: 100%;

  display: grid;
  grid-template-columns: auto 3fr 4fr;
  grid-template-rows: 55px auto;
  grid-gap: 0;
  margin: 0;
  padding: 0;
`;
